/**
 * Shoe Sizing Advice for BadmintonHQ
 * Displays single-line sizing advice with reduced font size
 */
(function() {
  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) {
    return;
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    setTimeout(initialize, 100); // Slight delay to ensure page is fully rendered
  }
  
  // Main initialization function
  function initialize() {
    // Check if this is a shoe product
    if (isShoeProduct()) {
      // Get the brand name
      const brandName = getBrandName();

      console.log('is shoe');
      
      // Find the concise fit information from the "SHOE SIZE LENGTH FIT" section
      const fitType = extractFitType();
      
      if (fitType && brandName) {
        // Format the advice text with brand name and fit type
        const url = window.location.pathname.toLowerCase();
        const title = document.title.toLowerCase();
        var sizeAdvice = `${brandName} Shoes are - ${fitType} fitting.`;
        if(url.includes('skates') || title.includes('skates')) {
          sizeAdvice = `${brandName} Skates are - ${fitType} fitting.`;
        }
        
        // Display the size information before the quantity box
        displaySizeAdvice(sizeAdvice);
      }
    }
  }
  
  // Check if this is a shoe product
  function isShoeProduct() {
    const url = window.location.pathname.toLowerCase();
    const title = document.querySelector('.product__title h1').innerText.toLowerCase();
    const breadcrumbs = document.querySelectorAll('.breadcrumbs__link, .breadcrumb__link');
    const productType = document.querySelector('.product-meta__type, .product__type')?.textContent.toLowerCase() || '';

    // Check URL and title
    if (url.includes('shoe') || url.includes('footwear') || 
        title.includes('shoe') || title.includes('footwear') ||
        productType.includes('shoe') || productType.includes('footwear') || url.includes('skates') || title.includes('skates')) {
      return true;
    }
    
    // Check breadcrumbs
    for (let i = 0; i < breadcrumbs.length; i++) {
      const text = breadcrumbs[i].textContent.toLowerCase();
      if (text.includes('shoe') || text.includes('footwear')) {
        return true;
      }
    }
    
    return false;
  }
  
  // Get the brand name from the product page
  function getBrandName() {
    // Try different selectors to find the brand
    const vendorElement = document.querySelector('.product-meta__vendor, .product__vendor');
    if (vendorElement) {
      return vendorElement.textContent.trim();
    }
    
    // Try to extract from title
    const title = document.querySelector('h1.product__title, .product-title')?.textContent || document.title;
    if (title) {
      // Extract the first word which is often the brand
      const firstWord = title.split(' ')[0];
      if (firstWord && firstWord.length > 2) {
        return firstWord.trim();
      }
    }
    
    // Fallback: extract from URL
    const url = window.location.pathname;
    const urlParts = url.split('/');
    const productSlug = urlParts[urlParts.length - 1];
    const brandFromUrl = productSlug.split('-')[0];
    
    if (brandFromUrl && brandFromUrl.length > 2) {
      return brandFromUrl.charAt(0).toUpperCase() + brandFromUrl.slice(1);
    }
    
    return "These";
  }
  
  // Extract ONLY the fit type (e.g., "True to Size") from the SHOE SIZE LENGTH FIT section
  function extractFitType() {
    // Find all potential description elements
    const descriptionElements = [
      ...document.querySelectorAll('.product__description'),
      ...document.querySelectorAll('.product-description'),
      ...document.querySelectorAll('.product-tab__content'),
      ...document.querySelectorAll('.product__accordion'),
      ...document.querySelectorAll('p')
    ];
    
    // Method 1: Look for elements containing "SHOE SIZE LENGTH FIT"
    for (const element of descriptionElements) {
      const textContent = element.textContent || '';
      
      if (textContent.includes('SHOE SIZE LENGTH FIT') || 
          textContent.includes('Shoe Size Length Fit') ||
          textContent.includes('shoe size length fit')) {
        
        // Extract the part that comes after "SHOE SIZE LENGTH FIT"
        const parts = textContent.split(/SHOE SIZE LENGTH FIT|Shoe Size Length Fit|shoe size length fit/i);
        
        if (parts.length > 1) {
          // Get the content after the heading
          let fitText = parts[1].trim();
          
          // Extract just the fit type (like "True to Size")
          const fitMatch = fitText.match(/(True to Size|Half size small|Half size large|Small fitting|Large fitting|Normal fitting|Standard fitting|Regular fitting)/i);
          
          if (fitMatch) {
            return fitMatch[0].trim();
          }
          
          // If no standard phrases found, try to extract the first short phrase
          const shortPhrase = fitText.split(/[.,;:\n]/)[0].trim();
          if (shortPhrase && shortPhrase.length < 30) {
            return shortPhrase;
          }
        }
      }
    }
    
    // Method 2: Look for specific fit indicators in the product description
    const fullText = descriptionElements.map(el => el.textContent || '').join(' ');
    
    // Check for specific phrases indicating fit
    const fitPhrases = [
      { regex: /true\s+to\s+size/i, value: "True to Size" },
      { regex: /half\s+size\s+small/i, value: "Half size small" },
      { regex: /half\s+a\s+size\s+small/i, value: "Half size small" },
      { regex: /1\/2\s+size\s+small/i, value: "Half size small" },
      { regex: /runs\s+small/i, value: "Small fitting" },
      { regex: /small\s+fitting/i, value: "Small fitting" },
      { regex: /narrow\s+fit/i, value: "Narrow fitting" },
      { regex: /wide\s+fit/i, value: "Wide fitting" }
    ];
    
    for (const phrase of fitPhrases) {
      if (phrase.regex.test(fullText)) {
        return phrase.value;
      }
    }
    
    // For Yonex shoes, use the standard Yonex sizing
    if (isYonexShoe()) {
      return "1/2 a size small";
    }
    
    // Default if no specific fit info is found
    return "True to Size";
  }
  
  // Check if this is a Yonex shoe
  function isYonexShoe() {
    const title = document.title.toLowerCase();
    const url = window.location.pathname.toLowerCase();
    const productVendor = document.querySelector('.product-meta__vendor, .product__vendor')?.textContent.toLowerCase() || '';
    
    return title.includes('yonex') || url.includes('yonex') || productVendor.includes('yonex');
  }
  
  // Display the size advice correctly positioned before the quantity box
  function displaySizeAdvice(sizeInfo) {
    // First, find and analyze the "Order within" text to match its style
    const orderWithinText = document.querySelector('.product__inventory, .inventory');
    let baseFontSize = '13px';
    let fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
    let textColor = '#BE163D';
    
    // Try to match the "Order within" text style if it exists
    if (orderWithinText) {
      const computedStyle = window.getComputedStyle(orderWithinText);
      baseFontSize = computedStyle.fontSize;
      fontFamily = computedStyle.fontFamily;
      // Keep the color red for visibility
    }
    
    // Reduce the font size by 30%
    const reducedFontSize = calculateReducedFontSize(baseFontSize, 0.7); // 30% reduction = multiply by 0.7
    
    // Create the advice element
    const adviceElement = document.createElement('div');
    adviceElement.className = 'shoe-sizing-advice';
    
    // Set the HTML with just the text (no icon)
    adviceElement.innerHTML = `
      <div class="shoe-sizing-advice-content">
        <span class="shoe-sizing-advice-text"><strong>Sizing Advice:</strong> ${sizeInfo}</span>
      </div>
    `;
    
    // Add the styles with reduced font size
    const styles = document.createElement('style');
    styles.textContent = `
      .shoe-sizing-advice {
        color: #393232;
        margin-bottom: 15px;
        margin-top: 8px;
        background-color: #e9e1e1;
        border-radius: 43px;
        font-size: 10.5px;
        font-family: Onset, sans-serif;
        line-height: 1.2;
        height: auto;
        overflow: visible;
        text-align: center;
        padding: 10px 10px 8px 10px;
        display: block;
    }
            
      .shoe-sizing-advice-content {
        display: flex;
        align-items: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      
      .shoe-sizing-advice-text {
        flex-grow: 1;
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
      
      @media (max-width: 768px) {
        .shoe-sizing-advice {
          font-size: ${reducedFontSize};
          padding: 7px 3px 6px;
        }
      }
    `;
    document.head.appendChild(styles);
    
    // Try to find the correct insertion point - BEFORE the quantity box
    const quantitySelector = document.querySelector('.product-form__quantity, .quantity-selector, input[name="quantity"], .product-form__input--quantity');
    
    if (quantitySelector) {
      // Look for the parent container of the quantity selector
      let container = quantitySelector;
      let depth = 0;
      
      // Go up the DOM tree to find a good container
      while (depth < 4 && container.parentElement) {
        container = container.parentElement;
        depth++;
        
        // If we found a good container, insert before it
        if (container.className.includes('quantity') || 
            container.className.includes('product-form__input') ||
            container.tagName === 'DIV') {
          container.parentElement.insertBefore(adviceElement, container);
          return;
        }
      }
      
      // If we couldn't find a good container, just insert before the quantity selector itself
      quantitySelector.parentElement.insertBefore(adviceElement, quantitySelector);
      return;
    }
    
    // Fallback: try to find the add to cart button and insert before it
    const addToCartButton = document.querySelector('.product-form__submit, button[name="add"]');
    if (addToCartButton) {
      const buttonContainer = addToCartButton.parentElement;
      buttonContainer.insertBefore(adviceElement, addToCartButton);
    }
  }
  
  // Helper function to reduce font size by percentage
  function calculateReducedFontSize(originalSize, factor) {
    // Extract the numeric value and unit from the font size
    const match = originalSize.match(/^([\d.]+)(\D+)$/);
    
    if (!match) {
      // Fallback if we can't parse the font size
      return '9px'; // 70% of 13px
    }
    
    const [, value, unit] = match;
    const reducedValue = parseFloat(value) * factor;
    
    return `${reducedValue.toFixed(1)}${unit}`;
  }
})();